import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar"
import { AppSidebar } from "./app-sidebar"
import { OfflineBanner } from "@/components/sync/offline-banner"

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <AppSidebar />
      {/*
        Constrain the inset to viewport height and make the inner content div
        the scroll container. This keeps the scrollbar visible when Radix
        Select/Dialog lock body scroll while open. scrollbar-gutter:stable
        reserves space for the gutter on the actual scroll container so the
        view doesn't shift when content grows or when a Radix overlay opens
        (do NOT put it on html/body — that makes react-remove-scroll-bar
        measure a phantom scrollbar and add margin-right to body, shifting
        the whole app left when a dropdown opens).
      */}
      <SidebarInset className="flex h-svh flex-col overflow-hidden print:h-auto print:overflow-visible">
        {/*
          Mobile-only top bar. Below md the sidebar is an overlay sheet, so a
          visible trigger is the only way to open navigation on touch devices.
        */}
        <header className="flex h-12 shrink-0 items-center gap-3 border-b px-4 md:hidden print:hidden">
          <SidebarTrigger className="-ml-1" />
          <span className="text-sm font-semibold">FlowPilot</span>
        </header>
        <OfflineBanner />
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 [scrollbar-gutter:stable] print:overflow-visible">
          {children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
